var exports = {
  "Fk": "x127c5a35--ecead0--slidein",
  "wK": "x127c5a35--ecead0--pin-icon",
  "eN": "x127c5a35--ecead0--pin-main",
  "G9": "x127c5a35--ecead0--pin-main-price",
  "BM": "x127c5a35--ecead0--pin-active",
};

module.exports = exports;
